import 'react-toastify/dist/ReactToastify.css'
import './index.scss'
import './styles/themes.scss'

import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import { applyTenantChrome } from './config/tenant.runtime'
import { persistor, store } from './reducers'
import reportWebVitals from './reportWebVitals'
import { applyTheme, getStoredStyle } from './utils/theme'
import { getStoredTimeZone, setUserTimeZone } from './utils/timezone'
window.process = window.process || {
  nextTick: (fun) => fun(),
}

// Apply the last-used site style synchronously, before first paint, so there is
// no flash of the default theme while Redux rehydrates the user's profile.
applyTheme(getStoredStyle())

// And the tenant's own tab title and favicon, which index.html can no longer carry now that
// one build serves every customer.
applyTenantChrome()

// Same idea for the user's timezone: apply the last-used one before first paint so
// timestamps do not render in the default zone and then jump once the profile loads.
setUserTimeZone(getStoredTimeZone())

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Provider store={store}>
    <PersistGate loading={<div></div>} persistor={persistor}>
      <Router>
        <App />
      </Router>
      <ToastContainer theme="colored" />
    </PersistGate>
  </Provider>,
)

reportWebVitals()
